import { render, staticRenderFns } from "./drawerClienti.vue?vue&type=template&id=b89a9acc"
import script from "./drawerClienti.vue?vue&type=script&lang=js"
export * from "./drawerClienti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports